<div class="mdc-chip" tabindex="0" :class="classObject()">
    <slot name="leading"></slot>
    <div class="mdc-chip__text">{{ text }}</div>

    <!-- Add clear icon only if the chip is removable -->
    <mom-icon title="Dismiss" v-if="removable" :svgIcon="'clear'"
        class="mdc-chip__icon mdc-chip__icon--trailing"
        ref="trailingIcon" tabindex="0" role="button">
    </mom-icon>
</div>
